var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var keyValueArrayToObject = function keyValueArrayToObject(records) {
  return records.reduce(function (o, r) {
    var _extends2;

    return _extends({}, o, (_extends2 = {}, _extends2[r.key] = r.value, _extends2));
  }, {});
};

var getJsonConfig = function getJsonConfig(obj, key) {
  try {
    return JSON.parse(keyValueArrayToObject(obj)[key]);
  } catch (e) {
    return;
  }
};
export { keyValueArrayToObject, getJsonConfig };